<template>
    <sys-register-base
        :loading="loading"
        @onSave="save"
        :model.sync="model"
        :title="title"
        icon="mdi-account-tie"
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="6">
                        <sys-select-teacher
                            :model.sync="model.teacher_id"
                            :data.sync="model.teacher"
                            :error="errors.length > 0"
                            :errors="errors.teacher_id"
                            label="Professor*"
                            autofocus
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <sys-select-teacher-contract
                            :model.sync="model.teacher_contract_id"
                            :error="errors.length > 0"
                            :errors="errors.teacher_contract_id"
                            label="Contrato"
                            :teacherId="model.teacher_id"
                            clearable
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <sys-select-user
                            :model.sync="model.user_id_manager"
                            :data.sync="model.user_manager"
                            :error="errors.length > 0"
                            :errors="errors.user_id_manager"
                            label="Gestor*"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <emc-calendar-date-picker2
                            :model.sync="model.date_start"
                            label="Data Início"
                            :errorMessages="errors.date_start"
                            :show="dialog"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <emc-calendar-date-picker2
                            :model.sync="model.date_end"
                            label="Data Fim"
                            :errorMessages="errors.date_end"
                            :show="dialog"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" sm="4" class="d-flex align-center">
                        <v-switch inset v-model="model.active" label="Ativo"></v-switch>
                    </v-col>
                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysTeacherManagerRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {

        dialog(dialog_new, dialog_old) {

            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {

            this.dialog = show_new;

            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.active = 1;
                }

            }
        },

    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-account-tie"
        },
        title: {
            type: String,
            default: "Gestor"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionUpdateUserTeacher', 'ActionCreateUserTeacher']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateUserTeacher(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateUserTeacher(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>
